let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("3XRbj")).then(() => parcelRequire('c3Tsk'));